import { useEffect, useState, lazy, Suspense } from "react";
import { useCommunity } from "../../context/community";
import { Redirect } from "react-router-dom";
import LangService from "../../services/LangService";
import defaultCommunityInfo from "./assets/defaultCommunityInfo";
import { voleeApi } from "../../api/VoleeApi";
import Section from "./components/Section";
import { getBlock } from "./components/blocks/getBlock";
import AboutBlock from "./components/blocks/AboutBlock";

const ShortLanding = lazy(() => import('./components/ShortLanding/ShortLanding'));
const Landing = lazy(() => import('./components/Landing/Landing'));

const convertCommunityInfo = (communityInfo) => {
    if (communityInfo.version === 2) {
        return communityInfo;
    }
    const blocks = [];
    if (communityInfo.firstScreen) {
        blocks.push({
            ...communityInfo.firstScreen,
            type: "first",
            position: 0,
        });
    }
    if (communityInfo.secondScreen) {
        blocks.push({
            ...communityInfo.secondScreen,
            type: "icons",
            position: 1,
        });
    }
    if (communityInfo.thirdScreen) {
        blocks.push({
            ...communityInfo.thirdScreen,
            type: "how-it-works",
            position: 2,
        });
    }
    if (communityInfo.forthScreen) {
        blocks.push({
            ...communityInfo.forthScreen,
            type: "first",
            position: 0,
        });
    }
    return {
        communityName: communityInfo.communityName,
        domain: communityInfo.domain,
        footer: communityInfo.footer || {},
        type: communityInfo.type || {},
        blocks,
    };
};

const Welcome = () => {
    const { community } = useCommunity();
    const [communityInfo, setCommunityInfo] = useState(
        convertCommunityInfo(defaultCommunityInfo())
    );

    useEffect(() => {
        (async () => {
            try {
                let domain;
                const subdomains = window.location.hostname.split(".");
                if (community.domain) {
                    domain = community.domain;
                } else if (subdomains.length > 1) {
                    domain = subdomains[0];
                }

                const localLang = localStorage.getItem("local") || LangService.lang;
                const shouldChangeLandingLang =
                    Array.isArray(community.langChoices) &&
                    community.langChoices.includes(localLang) &&
                    communityInfo.lang !== localLang;
                const isDefaultLang = community.lang === localLang;

                if (
                    domain &&
                    domain !== "volee" && (
                        domain !== communityInfo.domain ||
                        shouldChangeLandingLang
                    )
                ) {
                    const langSuffix = shouldChangeLandingLang && !isDefaultLang ? "_" + localLang : "";
                    const communityInfoData = await voleeApi.landing.get(domain, langSuffix);

                    if (
                        communityInfoData &&
                        typeof communityInfoData === "object"
                    ) {
                        setCommunityInfo(
                            convertCommunityInfo(communityInfoData)
                        );
                    }
                } else if (!community.domain || community.domain === "volee") {
                    setCommunityInfo(convertCommunityInfo(defaultCommunityInfo()));
                }
            } catch (e) {
                // use default community info
                setCommunityInfo(convertCommunityInfo(defaultCommunityInfo()));
            }
        })();
    }, [community.domain, community.lang, community.langChoices, LangService.lang]);

    if (communityInfo.type && communityInfo.type === "lite") {
        return <Redirect to={{ pathname: "/login" }} />;
    } else if (community.isTimCommunity) {
        return <Suspense fallback={<div></div>}>
            <Landing community={community} communityInfo={communityInfo} />
        </Suspense>
    } else if (community.shortLanding) {
        return <Suspense fallback={<div></div>}>
            <ShortLanding community={community} communityInfo={communityInfo} />
        </Suspense>
    } else {
        return (
            <>
                {communityInfo.blocks
                    .sort((blockA, blockB) => blockA.position - blockB.position)
                    .map((block) => (
                        <Section key={block.type} block={block}>
                            {getBlock(block, community)}
                        </Section>
                    ))}
                {!communityInfo.footer.isHidden && (
                    <Section>
                        <AboutBlock communityInfo={communityInfo} />
                    </Section>
                )}
            </>
        );
    }
};

export default Welcome;
